export default "__VITE_ASSET__BPxOXNlp__"